<ng-container>
  <!-- reusable audio player pill (identical to Partition detail) -->
  <ng-template #player let-TTS="tts">
    <ng-container *ngIf="TTS && TTS.type !== 0">
      <ng-container *ngIf="!TTS.isFailed">
        <div class="tts-type" (click)="$event.stopPropagation(); toggleAudioPlay(TTS)" [class.audio-playing]="TTS.isAudioLoad" [class.disabled]="!TTS.isAudioLoad && isAudioPlay">
          <div style="height:16px;width:16px;">
            <ng-container *ngIf="TTS.isAudioLoading">
              <div class="btn-loader">
                <svg class="circular" viewBox="25 25 50 50">
                  <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
                </svg>
              </div>
            </ng-container>
            <ng-container *ngIf="TTS.isAudioPlay && isAudioPlay && !TTS.isAudioLoading">
              <div class="flex">
                <svg width="16" height="16" viewBox="0 0 24 24">
                  <defs>
                    <clipPath id="volume-clip-{{TTS.id}}">
                      <rect x="15" y="0" height="24" width="9"></rect>
                    </clipPath>
                  </defs>
                  <g class="audio-waves" clip-path="url(#volume-clip-{{TTS.id}})">
                    <circle cx="12.5" cy="12" r="3.25" fill="none" stroke="white" stroke-width="1.5"></circle>
                    <circle cx="12.5" cy="12" r="6.5" fill="none" stroke="white" stroke-width="1.5"></circle>
                    <circle cx="12.5" cy="12" r="9.75" fill="none" stroke="white" stroke-width="1.5"></circle>
                  </g>
                  <polygon points="3,9 7,9, 12,4 12,20 7,15 3,15" fill="white"></polygon>
                </svg>
              </div>
            </ng-container>
            <ng-container *ngIf="!TTS.isAudioLoad && !TTS.isAudioLoading">
              <div class="flex"><i class="material-icons">volume_up</i></div>
            </ng-container>
          </div>
          <ng-container *ngIf="TTS.isDefault"><span style="margin:0 5px;font-size: 13px;">Voice File</span></ng-container>
          <ng-container *ngIf="!TTS.isDefault && (TTS.type === 1 || TTS.type === 3)"><span style="margin:0 5px;font-size: 13px;">Voice file</span></ng-container>
          <ng-container *ngIf="!TTS.isDefault && TTS.type === 2"><span style="margin:0 5px;font-size: 13px;">TTS</span></ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="TTS.isFailed">
        <div class="tts-type failed" (click)="$event.stopPropagation(); playAudio(TTS)">
          <div class="flex"><i class="material-icons">refresh</i></div>
          <span style="margin:0 5px;">Failed</span>
        </div>
      </ng-container>
    </ng-container>
  </ng-template>

  <div class="warning-badge"><i class="material-icons icon">warning</i>
    <div class="description">The changes will be applied starting from newly created partitions. Existing partitions will not be affected.</div>
  </div>
  <div style="display: flex;justify-content: end;padding: 6px 20px;">
    <div class="btn-area" *ngIf="isEditMode" style="gap: 8px;">
      <div class="button button-white" (click)="onClickCancel()">
        <div class="btn-inner">Cancel</div>
      </div>
      <div class="button button-primary" [class.disabled]="isDisabledSave()" (click)="onClickSave()">
        <div class="btn-inner">Save</div>
      </div>
    </div>
    <div class="btn-area" *ngIf="!isEditMode">
      <div class="button button-white" (click)="onClickEdit()">
        <div class="btn-inner">Edit</div>
      </div>
    </div>
  </div>
  <div class="tab-table">
    <div class="table-area">
      <div class="content-body table-container" [class.is-edit-mode]="isEditMode">
        <table class="table-header">
          <colgroup>
            <col *ngFor="let col of tableHeader" [width]="col.width"/>
          </colgroup>
          <thead>
            <tr>
              <th *ngFor="let header of tableHeader">
                {{header.name}}
              </th>
            </tr>
          </thead>
        </table>
        <div class="loader absolute" *ngIf="isLoading">
          <svg class="circular" viewBox="25 25 50 50">
            <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
          </svg>
        </div>
        <div class="table-body" *ngIf="!isLoading">
          <table>
            <colgroup>
              <col *ngFor="let col of tableHeader" [width]="col.width"/>
            </colgroup>
            <tbody>
              <!-- Alarm Entry Delay -->
              <tr>
                <td>
                  <div class="between">
                    <div>Entry Delay</div>
                    <div class="tooltip-content" id="entry-delay-tooltip-box" (mouseenter)="setTooltipPosition('entry-delay-tooltip')">
                      <comp-icon class="tooltip-icon" [icon]="'info'" [size]="16" [color]="'#A2A6AD'"></comp-icon>
                      <div class="tooltip" id="entry-delay-tooltip">Within the entry zone that you enter to turn off the arm, the event is not generated for a set amount of time.</div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="recommend-value">60s</div>
                </td>
                <td>
                  <div *ngIf="!isEditMode">{{ originSettings.entryDelay }}s</div>
                  <div class="v-center" *ngIf="isEditMode">
                    <div class="input-suffix-container">
                      <input class="input-field" type="number" name="entryDelay" [(ngModel)]="partitionSettings.entryDelay" [min]="10" [max]="900" (keyup)="validateEntryDelay()" (change)="validateEntryDelay()"/><span class="suffix">s</span>
                    </div>
                    <div class="range-description">Range: 10s - 900s</div>
                    <div class="warning" *ngIf="isHasError.entryDelay">Please enter a value within the allowed range.</div>
                  </div>
                </td>
              </tr>

              <!-- Exit Delay -->
              <tr>
                <td>
                  <div class="between">
                    <div>Exit Delay</div>
                    <div class="tooltip-content" id="exit-delay-tooltip-box" (mouseenter)="setTooltipPosition('exit-delay-tooltip')">
                      <comp-icon class="tooltip-icon" [icon]="'info'" [size]="16" [color]="'#A2A6AD'"></comp-icon>
                      <div class="tooltip" id="exit-delay-tooltip">Even after changing to the arm state for going out, the event is not generated for the set time in the exit zone. Reduce unnecessary events.</div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="recommend-value">120s</div>
                </td>
                <td>
                  <div *ngIf="!isEditMode">{{ originSettings.exitDelay }}s</div>
                  <div class="v-center" *ngIf="isEditMode">
                    <div class="input-suffix-container">
                      <input class="input-field" type="number" name="exitDelay" [(ngModel)]="partitionSettings.exitDelay" [min]="10" [max]="900" (keyup)="validateExitDelay()" (change)="validateExitDelay()"/><span class="suffix">s</span>
                    </div>
                    <div class="range-description">Range: 10s - 900s</div>
                    <div class="warning" *ngIf="isHasError.exitDelay">Please enter a value within the allowed range.</div>
                  </div>
                </td>
              </tr>

              <!-- Bell Duration -->
              <tr>
                <td>
                  <div class="between">
                    <div>Bell Duration</div>
                    <div class="tooltip-content" id="bell-duration-tooltip-box" (mouseenter)="setTooltipPosition('bell-duration-tooltip')">
                      <comp-icon class="tooltip-icon" [icon]="'info'" [size]="16" [color]="'#A2A6AD'"></comp-icon>
                      <div class="tooltip" id="bell-duration-tooltip">The duration that the system alarm "bell" stays active after an alarm is triggered.</div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="recommend-value">5 min</div>
                </td>
                <td>
                  <div *ngIf="!isEditMode">{{ originSettings.bellDuration }} min</div>
                  <div class="v-center" *ngIf="isEditMode">
                    <div class="input-suffix-container">
                      <input class="input-field" type="number" name="bellDuration" [(ngModel)]="partitionSettings.bellDuration" [min]="0" [max]="60" (keyup)="validateBellDuration()" (change)="validateBellDuration()"/><span class="suffix">min</span>
                    </div>
                    <div class="range-description">Range: 0 - 60 min</div>
                  </div>
                </td>
              </tr>

              <!-- System Audio Alerts -->
              <tr *ngFor="let row of audioAlertRows">
                <td>
                  <div class="between">
                    <div>System Audio Alert<br/>{{ row.label }}</div>
                  </div>
                </td>
                <!-- CHEKT default -->
                <td>
                  <div class="recommend-value">Enabled<span *ngIf="chektDefaultName(row)"> / {{ chektDefaultName(row) }}</span></div>
                </td>
                <!-- Dealer default: enable + audio -->
                <td>
                  <!-- View mode -->
                  <div class="v-center" *ngIf="!isEditMode" style="gap: 10px;">
                    <span class="tag" [ngClass]="computedTagStyleClass(getOriginAlert(row.key).enabled)">{{ getOriginAlert(row.key).enabled ? 'Enabled' : 'Disabled' }}</span>
                    <ng-container *ngIf="viewTts(row.key) as TTS; else noAudioView">
                      <div style="display:flex;align-items:center;" [title]="TTS.text">
                        <ng-container *ngTemplateOutlet="player; context: { tts: TTS }"></ng-container>
                        <span class="ellipsis" style="max-width:220px;">{{ TTS.title ? TTS.title : TTS.text }}</span>
                      </div>
                    </ng-container>
                    <ng-template #noAudioView><span style="color: rgba(0,0,0,0.4);">-</span></ng-template>
                  </div>

                  <!-- Edit mode: toggle + preview player + selectable dropdown -->
                  <div class="v-center" *ngIf="isEditMode" style="gap: 10px;" (click)="$event.stopPropagation()">
                    <mat-slide-toggle [(ngModel)]="getAlert(row.key).enabled">
                      <div>{{ getAlert(row.key).enabled ? 'Enabled' : 'Disabled' }}</div>
                    </mat-slide-toggle>
                    <ng-container *ngTemplateOutlet="player; context: { tts: editTts(row.key) }"></ng-container>
                    <div class="relative" style="flex: 1; min-width: 0;">
                      <div class="selectbox label" (click)="toggleMenu(row.key, $event)" [title]="editTts(row.key)?.text || editTts(row.key)?.title">
                        <div class="flex between" style="max-width: calc(100% - 16px); width: 100%;">
                          <div class="ellipsis" [class.no-info]="!editTts(row.key)">
                            {{ editTts(row.key)?.title || editTts(row.key)?.text || 'Select Audio' }}
                          </div>
                          <div class="type-label" *ngIf="editTts(row.key) as sel">
                            <span *ngIf="sel.isDefault">Default</span>
                            <span *ngIf="!sel.isDefault && (sel.type === 1 || sel.type === 3)">Audio File</span>
                            <span *ngIf="!sel.isDefault && sel.type === 2">Google TTS</span>
                          </div>
                        </div>
                        <div style="width: 18px">
                          <svg xmlns="http://www.w3.org/2000/svg" height="18px" width="18px" viewBox="0 0 24 24" fill="#000000">
                            <path d="M12 4L16.58 8.59L15.17 10L12 6.83L8.83 10L7.41 8.59L12 4Z"></path>
                            <path d="M12 17.17L15.17 14 L16.59 15.41L12 20L7.42 15.41L8.83 14L12 17.17Z"></path>
                          </svg>
                        </div>
                      </div>
                      <div class="filter-box" *ngIf="openMenu === row.key">
                        <div class="select-list" [style.top.px]="menuTop" [style.left.px]="menuLeft" [style.width.px]="menuWidth" style="font-weight: 400;">
                          <div style="max-height: 220px; overflow-y: auto;">
                            <!-- clear selection -->
                            <div class="select-result has-child selectitem" (click)="selectTts(row.key, null)" [class.selected]="getAlert(row.key).ttsId == null">
                              <div class="ellipsis no-info">None</div>
                            </div>
                            <!-- CHeKT default -->
                            <div class="select-result has-child selectitem" *ngIf="getRowDefaultTts(row) as defaultTts" (click)="selectTts(row.key, defaultTts)" [class.selected]="getAlert(row.key).ttsId === defaultTts.id">
                              <div class="flex between" style="width: 100%;">
                                <div class="ellipsis">{{ defaultTts.title || defaultTts.text || 'No Info' }}</div>
                                <div class="type-label"><span>Default</span></div>
                              </div>
                            </div>
                            <!-- dealer TTS files (default only) -->
                            <div class="select-result has-child selectitem" *ngFor="let tts of selectableDealerTTS()" (click)="selectTts(row.key, tts)" [class.selected]="getAlert(row.key).ttsId === tts.id">
                              <div class="flex between" style="width: 100%;">
                                <div class="ellipsis" [class.no-info]="!tts.text && !tts.title">{{ tts.title || tts.text || 'No Info' }}</div>
                                <div class="type-label">
                                  <span *ngIf="tts.type === 1 || tts.type === 3">Audio File</span>
                                  <span *ngIf="tts.type === 2">Google TTS</span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</ng-container>
